"use client";
import { useAppDispatch, useAppSelector } from "lib/redux/hooks";
import {
  selectSettings,
  setCurrentSection,
  setTemplateWithDefaults,
} from "lib/redux/settingsSlice";
import Image from "next/image";
import { useTemplateComponents } from "components/Resume/templateUtils";
import { useTailwindBreakpoints } from "lib/hooks/useTailwindBreakpoints";
import { changeTemplateId, selectResume } from "lib/redux/resumeSlice";

export const TemplatePreview = ({ previewTemplateId }: any) => {
  const resume = useAppSelector(selectResume);
  const settings = useAppSelector(selectSettings);
  const dispatch = useAppDispatch();
  const { templateList } = useTemplateComponents(resume, settings);
  const selectedTemplate = templateList.find((t) => t.id === previewTemplateId);
  const { isLg, isXl, is2xl } = useTailwindBreakpoints();
  const handleTemplateChange = (template: number) => {
    dispatch(setTemplateWithDefaults(template));
    dispatch(changeTemplateId(template));
  };
  const handleMobileTemplateChange = (template: number) => {
    dispatch(setTemplateWithDefaults(template));
    dispatch(changeTemplateId(template));
    dispatch(setCurrentSection("personalDetails"));
  };
  return (
    <div className="relative">
      {selectedTemplate?.imageUrl ? (
        <Image
          src={selectedTemplate.imageUrl}
          alt={selectedTemplate.name || "Template Preview"}
          width={is2xl ? 467 : isXl ? 369 : 300}
          height={is2xl ? 600 : isXl ? 467 : 500}
          loading="eager"
          priority={true}
          fetchPriority="high"
          placeholder="blur"
          blurDataURL={
            "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 10' width='10' height='10'><rect width='10' height='10' fill='%23EEEEEE' /></svg>"
          }
          className="relative mx-auto rounded-[10px]"
        />
      ) : (
        <div>No preview available</div> // fallback content if image is not found
      )}
      <button
        onClick={() => {
          handleTemplateChange(selectedTemplate?.id!);
          dispatch(setCurrentSection("personalDetails"));
        }}
        className="btn-gradient mx-auto mt-4 hidden rounded-3xl px-12 py-2 lg:block xl:px-16 xl:py-3"
      >
        Use this
      </button>
      <button
        onClick={() => handleMobileTemplateChange(selectedTemplate?.id!)}
        className="btn-gradient mx-auto mt-2 block rounded-3xl px-12 py-2 lg:hidden xl:px-16 xl:py-3"
      >
        Use this
      </button>
    </div>
  );
};
